import styled from 'styled-components';

export const EventDetailBookingsContent = styled.div`
  padding-top: 48px;
`;

export const VirtualizedTableContainer = styled.div`
  height: calc(100% - 71px);
`;
